import { AxiosResponse } from 'axios'
import { api } from 'API'
import {
  ITrainingAssignment,
  ITrainingAssignmentSearchFilterDto,
  ICreateTrainingAssignmentDto,
  ITrainingAssignmentDetail,
  ITrainingAssignmentSummary,
  IActivityLogResponse,
  ActivityType
} from 'interfaces/training-assignment'

const BASE = '/training-assignments'

export async function searchTrainingAssignments(
  filterDto: ITrainingAssignmentSearchFilterDto,
  orgId?: number
): Promise<{ results: ITrainingAssignment[]; totalCount: number }> {
  // orgId (query) scopes the call to one team, overriding the interceptor's
  // global active-org stamp. BE resolves org scope from `?orgId=`, not the body.
  const response: AxiosResponse = await api.post(
    `${BASE}/search`,
    filterDto,
    orgId != null ? { params: { orgId } } : undefined
  )
  return response.data
}

export async function createTrainingAssignment(
  dto: ICreateTrainingAssignmentDto,
  orgId?: number
): Promise<ITrainingAssignment> {
  const response: AxiosResponse = await api.post(BASE, dto, orgId != null ? { params: { orgId } } : undefined)
  return response.data
}

export async function updateTrainingAssignmentById(id: number, data: Partial<ITrainingAssignment>): Promise<void> {
  await api.patch(`${BASE}/${id}`, data)
}

export async function archiveMultipleTrainingAssignments(ids: number[]): Promise<void> {
  await api.patch(`${BASE}/archive-multiple`, { ids })
}

export async function restoreMultipleTrainingAssignments(ids: number[]): Promise<void> {
  await api.patch(`${BASE}/restore-multiple`, { ids })
}

export async function getTrainingAssignmentDetail(
  id: number,
  enrollmentId?: number
): Promise<ITrainingAssignmentDetail> {
  const params = enrollmentId ? { enrollmentId } : {}
  const response: AxiosResponse = await api.get(`${BASE}/${id}/detail`, { params })
  return response.data
}

export async function getTrainingAssignmentSummary(id: number): Promise<ITrainingAssignmentSummary> {
  const response: AxiosResponse = await api.get(`${BASE}/${id}/summary`)
  return response.data
}

export interface IEnrollPlayersDto {
  membershipIds: number[]
}

export async function enrollPlayersToAssignment(id: number, dto: IEnrollPlayersDto): Promise<void> {
  await api.post(`${BASE}/${id}/enroll`, dto)
}

export interface IActivityLogQueryParams {
  assignmentId: number
  cursor?: string
  cursorId?: number
  limit?: number
  type?: ActivityType
  membershipId?: number
  sort?: 'newest' | 'oldest'
}

export async function getActivityLogs(params: IActivityLogQueryParams): Promise<IActivityLogResponse> {
  const response: AxiosResponse = await api.get('/player-assignment-activity-logs', { params })
  return response.data
}
